
import React from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';

type StructuredDataProps = {
  type: 'WebSite' | 'Organization' | 'BreadcrumbList' | 'FAQPage' | 'Course';
  data: any;
};

/**
 * Component to add structured data (JSON-LD) to pages for improved SEO
 */
const StructuredData: React.FC<StructuredDataProps> = ({ type, data }) => {
  if (!type || !data) {
    console.warn('StructuredData component received invalid props:', { type, data });
    return null;
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
